import IApiCaller from './IApiCaller';
import { Konkurrence } from '../../models/Konkurrence';
import { Tilmelding } from '../../models/Tilmelding';
import { Hold } from '../../models/Hold';
import { KonkurrenceMedTilmeldinger } from '../../models/KonkurrenceMedTilmeldinger';
import { ValidationResult } from '../ValidationResult';
import { getBackendBaseUrl } from '../BackendUrlResolver';
import { Bruger } from '../../models/Bruger';
import { getSite } from '../site/SiteProvider';
import { TilmeldingerForKonkurrence } from '../../models/TilmeldingerForKonkurrence';
import { Opgavepakke } from '../../models/Opgavepakke';
import { Logbog } from '../../models/Logbog';
import { KonkurrenceTilLaerer } from '../../models/KonkurrenceTilLaerer';
import { KonkurrenceOverblik } from '../../models/KonkurrenceOverblik';
import { Opgave } from '../../models/Opgave';
import { OpgaveListItem } from '../../models/OpgaveListItem';
import { OpgaveDelopgaver } from '../../models/OpgaveDelopgaver';
import { BedoemmelseTabel } from '../../models/BedoemmelseTabel';
import { ForsoegAdd } from '../../models/ForsoegAdd';
import { MultipleChoiceBesvarelse } from '../../models/MultipleChoiceBesvarelse';
import { MultipleChoiceSvarSave } from '../../models/MultipleChoiceSvarSave';
import { MultipleChoiceAfslut } from '../../models/MultipleChoiceAfslut';
import { Spoergsmaal } from '../../models/Spoergsmaal';
import { OpretLogbogIndlaeg } from '../../models/OpretLogbogIndlaeg';
import { DetailedOpgavepakkeOpgave } from '../../models/DetailedOpgavepakkeOpgave';
import { LogbogIndlaeg } from '../../models/LogbogIndlaeg';
import { ScoreboardKonfiguration } from '../../models/ScoreboardKonfiguration';
import { ScoreboardTabel } from '../../models/ScoreboardTabel';
import { SamletPlacering } from '../../models/SamletPlacering';
import { Vejledning } from '../../models/Vejledning';
import { KontaktSpoergsmaal } from '../../models/KontaktSpoergsmaal';
import { ErrorTypeEnum } from '../../models/enums/ErrorTypeEnum';
import { Institution } from '../../models/Institution';
import { OpgavepakkeScoreboardKonfiguration } from '../../models/OpgavepakkeScoreboardKonfiguration';
import { Kommune } from '../../models/Kommune';
import { KonkurrenceDelopgaveAfslutningstidspunkt } from '../../models/KonkurrenceDelopgaveAfslutningstidspunkt';
import { Afslutningstidspunkt } from '../../models/Afslutningstidspunkt';
import { Login } from '../../models/Login';
import { EksternBruger } from '../../models/EksternBruger';
import { EksternBrugerAktiveringsPublicModel } from '../../models/EksternBrugerAktiveringsPublicModel';
import { EksternBrugerPasswordResetTokenPublicModel } from '../../models/EksternBrugerPasswordResetTokenPublicModel';
import { EksternBrugerAktiverPublicModel } from '../../models/EksternBrugerAktiverPublicModel';
import { EksternBrugerPasswordResetPublicModel } from '../../models/EksternBrugerPasswordResetPublicModel';
import { KonkurrenceTilEkstern } from '../../models/KonkurrenceTilEkstern';
import { KonkurrenceOverblikEkstern } from '../../models/KonkurrenceOverblikEkstern';
import { DetailedOpgavepakkeOpgaveEkstern } from '../../models/DetailedOpgavepakkeOpgaveEkstern';
import { UniloginBruger } from '../../models/UniloginBruger';

class ApiCaller implements IApiCaller {
  updateMultipleChoiceSvar(
    svar: MultipleChoiceSvarSave
  ): Promise<ValidationResult> {
    return this.put('/api/multipleChoiceBesvarelse/retSvar', svar);
  }

  getOpgavepakkePlaceringer(
    konkurrenceId: string,
    opgavepakkeId: string
  ): Promise<SamletPlacering[]> {
    return this.get(
      '/api/konkurrenceResultat/getOpgavepakkePlaceringer/' +
        konkurrenceId +
        '/' +
        opgavepakkeId
    );
  }

  GetKonkurrenceResultat(
    konkurrenceId: string,
    konfigurationId: string
  ): Promise<ScoreboardTabel> {
    return this.get(
      '/api/konkurrenceResultat/' + konkurrenceId + '/' + konfigurationId
    );
  }

  GetHoldByKonkurrence(konkurrenceId: string): Promise<Hold[]> {
    return this.get(
      '/api/hold/GetHoldForKonkurrence?konkurrenceId=' + konkurrenceId
    );
  }

  GetHoldByKonkurrenceAndOpgave(
    konkurrenceId: string,
    opgaveId: string,
    indtastForAlle: boolean = false
  ): Promise<Hold[]> {
    return this.get(
      '/api/hold/GetHoldForKonkurrenceOgOpgave?konkurrenceId=' +
        konkurrenceId +
        '&opgaveId=' +
        opgaveId +
        '&indtastForAlle=' +
        indtastForAlle
    );
  }

  getKommendeKonkurrenceOverblik(): Promise<KonkurrenceOverblik> {
    return this.get('/api/konkurrence/GetKommendeKonkurrenceOverblik');
  }

  afslutMultipleChoice(
    multipleChoiceAfslut: MultipleChoiceAfslut
  ): Promise<ValidationResult> {
    return this.post(
      '/api/multipleChoiceBesvarelse/afslutMultipleChoice',
      multipleChoiceAfslut
    );
  }

  addMultipleChoiceSvar(
    svar: MultipleChoiceSvarSave
  ): Promise<ValidationResult> {
    return this.post('/api/multipleChoiceBesvarelse/registrerSvar', svar);
  }

  getMultipleChoiceBesvarelser(
    konkurrenceId: string,
    delopgaveId: string,
    holdId: string
  ): Promise<MultipleChoiceBesvarelse> {
    return this.get(
      '/api/multipleChoiceBesvarelse/getBesvarelse?konkurrenceId=' +
        konkurrenceId +
        '&delopgaveId=' +
        delopgaveId +
        '&holdId=' +
        holdId
    );
  }

  deleteForsoeg(forsoegId: string): Promise<any> {
    return this.delete('/api/bedoemmelse/' + forsoegId);
  }

  addForsoeg(forsoegAdd: ForsoegAdd): Promise<ValidationResult> {
    return this.post('/api/bedoemmelse/', forsoegAdd);
  }

  getBedoemmelser(
    konkurrenceId: string,
    delopgaveId: string,
    opgaveId: string
  ): Promise<BedoemmelseTabel> {
    return this.get(
      '/api/bedoemmelse/GetBedoemmelser?konkurrenceId=' +
        konkurrenceId +
        '&delopgaveId=' +
        delopgaveId +
        '&opgaveId=' +
        opgaveId
    );
  }

  getOpgaverForKonkurrence(konkurrenceId: string): Promise<OpgaveDelopgaver[]> {
    return this.get(
      '/api/opgave/GetOpgaverForKonkurrence?konkurrenceId=' + konkurrenceId
    );
  }

  getOpgavepakkerForScoreboardKonfiguration(
    konkurrenceId: string
  ): Promise<OpgavepakkeScoreboardKonfiguration[]> {
    return this.get(
      '/api/opgave/GetOpgavepakkerForScoreboardKonfiguration?konkurrenceId=' +
        konkurrenceId
    );
  }

  getEksterneBrugere(): Promise<EksternBruger[]> {
    return this.get('/api/bruger/eksterneBrugere');
  }

  createEksternBrugerPasswordResetRequest(emailAdresse: string): Promise<any> {
    return this.post('/api/bruger/CreateResetPasswordRequest', emailAdresse);
  }

  getNulstilEksternBruger(
    nulstillingsGuid: string
  ): Promise<EksternBrugerPasswordResetTokenPublicModel> {
    return this.get('/api/bruger/ResetPassword?resetGuid=' + nulstillingsGuid);
  }
  nulstilEksternBruger(
    nulstillingsModel: EksternBrugerPasswordResetPublicModel
  ): Promise<any> {
    return this.post('/api/bruger/ResetPassword', nulstillingsModel);
  }

  getOpaveListItems(): Promise<OpgaveListItem[]> {
    return this.get('/api/opgave');
  }

  getOpgave(opgaveId: string): Promise<Opgave> {
    return this.get('/api/opgave/' + opgaveId);
  }

  createOpgave(opgave: Opgave): Promise<ValidationResult> {
    return this.post('/api/opgave', opgave);
  }

  updateOpgave(opgave: Opgave): Promise<ValidationResult> {
    return this.put('/api/opgave', opgave);
  }

  deleteOpgave(opgaveId: string): Promise<any> {
    return this.delete('/api/opgave/' + opgaveId);
  }

  aktiverOpgave(opgaveId: string): Promise<ValidationResult> {
    return this.post('/api/opgave/aktiverOpgave', opgaveId);
  }

  copyOpgave(opgaveId: string): Promise<ValidationResult> {
    return this.post('/api/opgave/GetKopierOpgave', opgaveId);
  }

  updateLogbog(logbog: Logbog): Promise<ValidationResult> {
    return this.put('/api/logbog', logbog);
  }

  getLogboeger(): Promise<Logbog[]> {
    return this.get('/api/logbog/');
  }

  getLogbog(logbogId: string): Promise<Logbog> {
    return this.get('/api/logbog/' + logbogId);
  }

  getKommendeKonkurrencerTilLaerer(): Promise<KonkurrenceTilLaerer[]> {
    return this.get('/api/konkurrence/getKommendeTilLaerer');
  }

  getKommendeKonkurrencerTilEkstern(): Promise<KonkurrenceTilEkstern[]> {
    return this.get('/api/konkurrence/GetKommendeTilEkstern');
  }

  GetTidligereKonkurrencerTilLaerer(): Promise<KonkurrenceTilLaerer[]> {
    return this.get('/api/konkurrence/GetTidligereTilLaerer');
  }

  GetTidligereKonkurrencerTilEkstern(): Promise<KonkurrenceTilEkstern[]> {
    return this.get('/api/konkurrence/GetTidligereTilEkstern');
  }

  GetAlleKonkurrencerTilLaerer(): Promise<KonkurrenceTilLaerer[]> {
    return this.get('/api/konkurrence/GetAlleTilLaerer');
  }

  GetAlleKonkurrencerTilInstitutionUdenLaerer(): Promise<
    KonkurrenceTilLaerer[]
  > {
    return this.get('/api/konkurrence/GetAlleTilInstitutionUdenLaerer');
  }

  GetAlleKonkurrencerTilEkstern(): Promise<KonkurrenceTilEkstern[]> {
    return this.get('/api/konkurrence/GetAlleTilEkstern');
  }

  getOpgavepakke(opgavepakkeId: string): Promise<Opgavepakke> {
    return this.get('/api/opgavepakke/' + opgavepakkeId);
  }

  getOpgavepakkeVejledning(opgavepakkeId: string): Promise<Vejledning> {
    return this.get(
      '/api/opgavepakke/GetOpgavepakkeVejledning/' + opgavepakkeId
    );
  }

  updateOpgavepakke(opgavepakke: Opgavepakke): Promise<ValidationResult> {
    return this.put('/api/opgavepakke', opgavepakke);
  }

  createOpgavepakke(opgavepakke: Opgavepakke): Promise<ValidationResult> {
    return this.post('/api/opgavepakke', opgavepakke);
  }

  createLogbog(logbog: Logbog): Promise<ValidationResult> {
    return this.post('/api/logbog', logbog);
  }

  getVejledning(type: string): Promise<Vejledning> {
    return this.get('/api/ContentManagement/getvejledning/' + type);
  }

  createVejledning(vejledning: Vejledning): Promise<ValidationResult> {
    return this.post('/api/ContentManagement/createvejledning', vejledning);
  }

  createLogbogIndlaeg(
    logbogIndlaeg: OpretLogbogIndlaeg
  ): Promise<ValidationResult> {
    return this.post('/api/logbog/indlaeg', logbogIndlaeg);
  }

  updateLogbogIndlaeg(logbogIndlaeg: LogbogIndlaeg): Promise<ValidationResult> {
    return this.put('/api/logbog/indlaeg', logbogIndlaeg);
  }

  getOpgavepakker(): Promise<Opgavepakke[]> {
    return this.get('/api/opgavepakke');
  }

  getKommuner(): Promise<Kommune[]> {
    return this.get('/api/kommune/getKommuner');
  }

  getDetailedOpgave(
    konkurrenceId: string,
    opgavePakkeOpgaveId: string,
    holdId: string
  ): Promise<DetailedOpgavepakkeOpgave> {
    return this.get(
      '/api/opgave/' +
        konkurrenceId +
        '/hold/' +
        holdId +
        '/opgavepakkeOpgave/' +
        opgavePakkeOpgaveId
    );
  }

  getDetailedOpgaveEkstern(
    konkurrenceId: string,
    opgavePakkeOpgaveId: string
  ): Promise<DetailedOpgavepakkeOpgaveEkstern> {
    return this.get(
      '/api/opgave/' +
        konkurrenceId +
        '/opgavepakkeOpgave/' +
        opgavePakkeOpgaveId
    );
  }

  getKonkurrenceOverblik(id: string): Promise<KonkurrenceOverblik> {
    return this.get('/api/konkurrence/getoverblik/' + id);
  }

  getKonkurrenceEksternOverblik(
    id: string
  ): Promise<KonkurrenceOverblikEkstern> {
    return this.get('/api/konkurrence/geteksternoverblik/' + id);
  }

  impersonateBruger(brugernavn: string): Promise<any> {
    return this.get('/api/auth/impersonateBruger?brugernavn=' + brugernavn);
  }

  deleteTilmelding(tilmeldingId: string): Promise<any> {
    return this.delete('/api/tilmelding/' + tilmeldingId);
  }

  deleteLogbog(logbogId: string): Promise<any> {
    return this.delete('/api/logbog/' + logbogId);
  }

  updateTilmelding(tilmelding: Tilmelding): Promise<ValidationResult> {
    return this.put('/api/tilmelding', tilmelding);
  }

  getTilmelding(tilmeldingId: string): Promise<Tilmelding> {
    return this.get('/api/tilmelding/' + tilmeldingId);
  }

  getTilmeldingerForKonkurrence(
    konkurrenceId: string
  ): Promise<TilmeldingerForKonkurrence[]> {
    return this.get(
      '/api/tilmelding/GetTilmeldingerForKonkurrence?konkurrenceId=' +
        konkurrenceId
    );
  }

  acceptTilmeldingInvitation(invitationId: string): Promise<ValidationResult> {
    return this.put(
      '/api/Invitation/AccepterInvitationTilLaerer?invitationId=' + invitationId
    );
  }

  createTilmeldingLaerer(
    konkurrence: KonkurrenceTilLaerer
  ): Promise<ValidationResult> {
    return this.post('/api/tilmelding/CreateTilmeldingLaerer', konkurrence);
  }

  getOrCreateBruger(uniloginBruger: UniloginBruger): Promise<Bruger> {
    return this.post('/api/bruger/GetOrCreateBruger', uniloginBruger, true);
  }

  updateBruger(bruger: Bruger): Promise<any> {
    const reponsePromise = this.getResponsePromise(
      '/api/bruger',
      'PUT',
      bruger,
      true
    );
    return reponsePromise.then((response: any) => {
      if (this.isResponseOk(response.status) || response.status === 422) {
        return response.json();
      } else {
        this.redirectOnError(response.status);
        return undefined;
      }
    });
  }

  brugerStamdataSat(brugernavn: string): Promise<boolean> {
    return this.get('/api/bruger/stamdataSat?brugernavn=' + brugernavn);
  }

  createEksternBruger(emailAdresse: string): Promise<any> {
    return this.post('/api/bruger/OpretEksternBruger', emailAdresse);
  }

  deleteEksternBruger(brugerId: string): Promise<any> {
    return this.post('/api/bruger/SletEksternBruger', brugerId);
  }

  gensendEksternBrugerInvitation(emailAdresse: string): Promise<any> {
    return this.post(
      '/api/bruger/GensendEksternBrugerInvitation',
      emailAdresse
    );
  }

  getAktiverEksternBruger(
    aktiveringsGuid: string
  ): Promise<EksternBrugerAktiveringsPublicModel> {
    return this.get(
      '/api/bruger/AktiverEksternBruger?aktiveringsGuid=' + aktiveringsGuid
    );
  }

  aktiverEksternBruger(
    aktiveringsModel: EksternBrugerAktiverPublicModel
  ): Promise<any> {
    return this.post('/api/bruger/AktiverEksternBruger', aktiveringsModel);
  }

  getUniLoginUrl(returnUrl: string): Promise<string> {
    return this.get('/api/auth/GetUniLoginUrl?returnUrl=' + returnUrl);
  }

  login(authCode: string): Promise<any> {
    return this.get('/api/auth/login?authCode=' + authCode);
  }

  loginAsExternalBruger(login: Login): Promise<any> {
    return this.post('/api/auth/login', login, true);
  }

  getAllScoreboardKonfigurationer(
    id: string
  ): Promise<ScoreboardKonfiguration[]> {
    return this.get(
      `/api/scoreboardkonfiguration/getallscoreboardkonfigurations/${id}`
    );
  }

  loginUdvikling(): Promise<any> {
    return this.get('/api/auth/loginUdvikling');
  }

  uploadImage(formData: FormData): Promise<string> {
    return this.getResponsePromise('/api/image/', 'POST', formData, false).then(
      (response) => this.handleFilePostResponse(response)
    );
  }

  getKonkurrencerMedTilmeldinger(): Promise<KonkurrenceMedTilmeldinger[]> {
    return this.get('/api/KonkurrenceMedTilmeldinger');
  }

  getHoldList(): Promise<Hold[]> {
    return this.get('/api/hold');
  }

  getHoldForBruger(brugernavn: string): Promise<Hold[]> {
    return this.get('/api/hold/GetHoldForBruger?brugernavn=' + brugernavn);
  }

  createTilmelding(tilmelding: Tilmelding): Promise<ValidationResult> {
    return this.post('/api/tilmelding', tilmelding);
  }

  getKonkurrencer(): Promise<Konkurrence[]> {
    return this.get('/api/konkurrence');
  }

  getKommendeKonkurrencer(): Promise<Konkurrence[]> {
    return this.get('/api/konkurrence/getKommende');
  }

  exportKonkurrenceOverblikToExcel(): Promise<any> {
    return this.get('/api/konkurrence/ExportKonkurrenceOverblikToExcel');
  }

  getKonkurrence(id: string): Promise<Konkurrence> {
    return this.get('/api/konkurrence/' + id);
  }

  createKonkurrence(konkurrence: Konkurrence): Promise<ValidationResult> {
    return this.post('/api/konkurrence', konkurrence);
  }

  updateKonkurrence(konkurrence: Konkurrence): Promise<ValidationResult> {
    return this.put('/api/konkurrence', konkurrence);
  }

  deleteKonkurrence(id: string): Promise<any> {
    return this.delete('/api/konkurrence/' + id);
  }

  getInstitutionerForBruger(): Promise<Institution[]> {
    return this.get('/api/bruger/getInstitutioner');
  }

  createScoreboardKonfiguration(
    konfiguration: ScoreboardKonfiguration
  ): Promise<ValidationResult> {
    return this.post(
      '/api/scoreboardkonfiguration/createkonfig',
      konfiguration
    );
  }

  updateScoreboardKonfiguration(
    konfiguration: ScoreboardKonfiguration | undefined
  ): Promise<ValidationResult> {
    return this.put('/api/scoreboardkonfiguration/updatekonfig', konfiguration);
  }

  deleteScoreboardKonfiguration(
    scoreboardKonfigurationId: string
  ): Promise<any> {
    return this.delete(
      '/api/scoreboardkonfiguration/' + scoreboardKonfigurationId
    );
  }

  createSpoergsmaal(spoergsmaal: Spoergsmaal): Promise<ValidationResult> {
    return this.post('/api/ofteststilledespoergsmaal/', spoergsmaal);
  }

  createKontaktSpoergsmaal(
    spoergsmaal: KontaktSpoergsmaal
  ): Promise<ValidationResult> {
    return this.post('/api/kontakt/', spoergsmaal);
  }

  setDelopgaveAfslutningstidspunkt(
    konkurrenceDelopgaveAfslutningstidspunkt: KonkurrenceDelopgaveAfslutningstidspunkt
  ): Promise<ValidationResult> {
    return this.post(
      '/api/opgave/setdelopgaveafslutningstidspunkt/',
      konkurrenceDelopgaveAfslutningstidspunkt
    );
  }

  getDelopgaveAfslutningstidspunkt(
    konkurrenceId: string,
    delopgaveId: string
  ): Promise<Afslutningstidspunkt> {
    return this.get(
      '/api/opgave/getdelopgaveafslutningstidspunkt/' +
        konkurrenceId +
        '/' +
        delopgaveId
    );
  }

  getDelete(url: string, httpMethod: string) {
    return this.getResponsePromise(url, httpMethod, undefined, false)
      .then((response) =>
        httpMethod === 'get'
          ? this.handleGetResponse(response)
          : this.handleDeleteResponse(response)
      )
      .catch((error) => {
        var errorMessage = 'Fejl ved kald af: ' + url + '. Error: ' + error;
        console.error(errorMessage);
        this.redirectToErrorPage(
          'Prøv igen, eller kontakt Naturvidenskabernes Hus.'
        );
      });
  }

  get(url: string) {
    return this.getDelete(url, 'get');
  }

  delete(url: string) {
    return this.getDelete(url, 'delete');
  }

  postPut(
    url: string,
    data: any,
    httpMethod: string,
    includeResponseData?: boolean
  ) {
    return this.getResponsePromise(url, httpMethod, data, true)
      .then((response) =>
        this.handlePostResponse(response, includeResponseData)
      )
      .catch((error) => {
        var errorMessage = 'Fejl fra handleResponse: ' + error;
        console.error(errorMessage);
        this.redirectToErrorPage(
          'Prøv igen, eller kontakt Naturvidenskabernes Hus.'
        );
      });
  }

  post(url: string, data: any, includeResponseData?: boolean) {
    return this.postPut(url, data, 'post', includeResponseData);
  }

  put(url: string, data?: any) {
    return this.postPut(url, data, 'put');
  }

  getResponsePromise(
    url: string,
    httpMethod: string,
    data: any,
    serializeToJson: boolean
  ): Promise<Response> {
    const fullUrl = getBackendBaseUrl() + url;

    let theHeaders = new Headers();
    theHeaders.append(
      'Authorization',
      'bearer ' + localStorage.getItem('token')
    );
    theHeaders.append('SiteUrl', window.location.host);
    theHeaders.append('Site', getSite().type.toString());
    theHeaders.append('pragma', 'no-cache');
    theHeaders.append('cache-control', 'no-cache');

    if (serializeToJson) {
      theHeaders.append('Accept', 'application/json');
      theHeaders.append('Content-Type', 'application/json');
    }

    var requestInit = {
      method: httpMethod,
      body: serializeToJson ? JSON.stringify(data) : data,
      headers: theHeaders,
    };

    // if (serializeToJson) {
    //    console.log(httpMethod + ' to: ' + fullUrl + ' JSON:' + JSON.stringify(data));
    // } else {
    //    console.log(httpMethod + ' to: ' + fullUrl);
    // }

    return fetch(fullUrl, requestInit);
  }

  handleGetResponse(response: any) {
    if (this.isResponseOk(response.status)) {
      return response.json();
    } else {
      this.redirectOnError(response);
    }
  }

  handleDeleteResponse(response: any) {
    if (this.isResponseOk(response.status)) {
      return response;
    } else {
      this.redirectOnError(response);
    }
  }

  handlePostResponse(response: any, includeResponseData?: boolean) {
    if (this.isResponseOk(response.status)) {
      let validationResult = new ValidationResult();
      validationResult.isValid = true;

      if (includeResponseData) {
        return response.json().then((data: any) => {
          return {
            data: data,
            validation: validationResult,
          };
        });
      } else {
        return validationResult;
      }
    } else if (response.status === 422) {
      return response.json();
    } else {
      this.redirectOnError(response);
    }
  }

  handleFilePostResponse(response: any) {
    if (this.isResponseOk(response.status)) {
      return response.text();
    } else {
      this.redirectOnError(response);
      return undefined;
    }
  }

  isResponseOk(status: number): boolean {
    return status >= 200 && status < 300;
  }

  redirectOnError(response: any) {
    let errorMessage = response.status + '-' + response.statusText;
    if (response.status === 400) {
      // tslint:disable-next-line:no-shadowed-variable
      response.json().then((json: any) => {
        if (json.errorType === ErrorTypeEnum.IkkeValgtInstitution) {
          errorMessage =
            'Du er tilknyttet flere institutioner i Uni-login, men har ikke valgt en tilknytning. Gå venligst til ind på din profil og vælg institution.';
          this.redirectToErrorPage(errorMessage);
        }
      });
    } else if (response.status === 401) {
      window.location.href = '/login';
    } else if (response.status === 403) {
      window.location.href = '/ikke-adgang';
    } else if (response.status === 502) {
      response.json().then((json: any) => {
        if (json.errorType === ErrorTypeEnum.UniLogin) {
          window.location.href = '/uni-login-driftsproblemer';
        }
      });
    } else if (response.status === 500) {
      this.redirectToErrorPage(
        'Prøv igen, eller kontakt Naturvidenskabernes Hus. '
      );
    }
  }

  redirectToErrorPage(errorMessage: string) {
    var urlEncoded = encodeURIComponent(errorMessage);
    window.location.href = '/error/' + urlEncoded;
  }
}

export default ApiCaller;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/infrastructure/api/ApiCaller.ts